export const BLANK_STRING = '';

export function isBlankString(string: string | undefined): boolean {
    return !string || Object.keys(string).length === 0 || string === BLANK_STRING || string.trim() === BLANK_STRING;
}

export function isNotBlankString(string: string | undefined): boolean {
    return !isBlankString(string);
}